{
    "Accessibility Menu": "輔助功能菜單",
    "Reset settings": "重置設定",
    "Close": "關閉",
    "Content Adjustments": "內容調整",
    "Adjust Font Size": "調整字體大小",
    "Highlight Title": "標題高亮",
    "Highlight Links": "連結高亮",
    "Readable Font": "易讀字體",
    "Color Adjustments": "色彩調整",
    "Dark Contrast": "高對比度（黑色）",
    "Light Contrast": "高對比度（白色）",
    "High Contrast": "高對比度",
    "High Saturation": "高飽和度",
    "Low Saturation": "低飽和度",
    "Monochrome": "單色",
    "Tools": "更多設定",
    "Reading Guide": "閱讀尺",
    "Stop Animations": "停止閃動",
    "Big Cursor": "放大滑鼠",
    "Increase Font Size": "增加字體大小",
    "Decrease Font Size": "減小字體大小",
    "Letter Spacing": "字母間距",
    "Line Height": "行距",
    "Font Weight": "字重",
    "Dyslexia Font": "閱讀障礙字體",
    "Language": "語言",
    "Open Accessibility Menu": "打開輔助功能菜單"
}